import BubblesIcon from '../assets/games/icons/bubbles.svg';
import BubblesBlackIcon from '../assets/games/icons/bubbles-black.svg';
import CalculatorIcon from '../assets/games/icons/calculator.svg';
import CalculatorBlackIcon from '../assets/games/icons/calculator-black.svg';
import ChaseIcon from '../assets/games/icons/chase.svg';
import ChaseBlackIcon from '../assets/games/icons/chase-black.svg';
import ConstructorIcon from '../assets/games/icons/constructor.svg';
import ConstructorBlackIcon from '../assets/games/icons/construktor-black.svg';
import CosmosIcon from '../assets/games/icons/cosmos.svg';
import CosmosBlackIcon from '../assets/games/icons/cosmos-black.svg';
import EastereggsIcon from '../assets/games/icons/eastereggs.svg';
import EastereggsBlackIcon from '../assets/games/icons/eastereggs-black.svg';
import FiremanIcon from '../assets/games/icons/fireman.svg';
import FiremanBlackIcon from '../assets/games/icons/fireman-black.svg';
import HopscotchIcon from '../assets/games/icons/hopscotch.svg';
import HopscotchBlackIcon from '../assets/games/icons/hopscotch-black.svg';
import MemoryIcon from '../assets/games/icons/memory.svg';
import MemoryBlackIcon from '../assets/games/icons/memory-black.svg';
import MinesweeperIcon from '../assets/games/icons/minesweeper.svg';
import MinesweeperBlackIcon from '../assets/games/icons/minesweeper-black.svg';
import MoleIcon from '../assets/games/icons/mole.svg';
import MoleBlackIcon from '../assets/games/icons/mole-black.svg';
import PipejetIcon from '../assets/games/icons/pipejet.svg';
import PipejetBlackIcon from '../assets/games/icons/pipejet-black.svg';
import RainIcon from '../assets/games/icons/rain.svg';
import RainBlackIcon from '../assets/games/icons/rain-black.svg';
import SnakeIcon from '../assets/games/icons/snake.svg';
import SnakeBlackIcon from '../assets/games/icons/snake-black.svg';
import SpeedwallIcon from '../assets/games/icons/speedwall.svg';
import SpeedwallIconBlack from '../assets/games/icons/speedwall-black.svg';
import StrikeIcon from '../assets/games/icons/strike.svg';
import StrikeBlackIcon from '../assets/games/icons/strike-black.svg';
import TakeoffIcon from '../assets/games/icons/takeoff.svg';
import TakeoffBlackIcon from '../assets/games/icons/takeoff-black.svg';
import { IGames } from '../types/types';

export const GAMES: IGames = {
  bubbles: {
    // name: 'Bubbles',
    name: 'Bańki',
    image: BubblesIcon,
    'image-black': BubblesBlackIcon,
  },
  calculator: {
    // name: 'Calculator',
    name: 'Plusik',
    image: CalculatorIcon,
    'image-black': CalculatorBlackIcon,
  },
  chase: {
    // name: 'Chase',
    name: 'Berek',
    image: ChaseIcon,
    'image-black': ChaseBlackIcon,
  },
  constructor: {
    // name: 'Constructor',
    name: 'Konstruktor',
    image: ConstructorIcon,
    'image-black': ConstructorBlackIcon,
  },
  cosmos: {
    // name: 'Cosmos',
    name: 'Kosmos',
    image: CosmosIcon,
    'image-black': CosmosBlackIcon,
  },
  eastereggs: {
    // name: 'Easter eggs',
    name: 'Pisanki',
    image: EastereggsIcon,
    'image-black': EastereggsBlackIcon,
  },
  fireman: {
    // name: 'Fireman',
    name: 'Strażak',
    image: FiremanIcon,
    'image-black': FiremanBlackIcon,
  },
  hopscotch: {
    // name: 'Hopscotch',
    name: 'Gra w klasy',
    image: HopscotchIcon,
    'image-black': HopscotchBlackIcon,
  },
  memory: {
    name: 'Memory',
    image: MemoryIcon,
    'image-black': MemoryBlackIcon,
  },
  minesweeper: {
    // name: 'Minesweeper',
    name: 'Saper',
    image: MinesweeperIcon,
    'image-black': MinesweeperBlackIcon,
  },
  mole: {
    // name: 'Mole',
    name: 'Kret',
    image: MoleIcon,
    'image-black': MoleBlackIcon,
  },
  pipejet: {
    name: 'PipeJet',
    image: PipejetIcon,
    'image-black': PipejetBlackIcon,
  },
  rain: {
    // name: 'Rain',
    name: 'Deszcz',
    image: RainIcon,
    'image-black': RainBlackIcon,
  },
  snake: {
    // name: 'Snake',
    name: 'Wąż',
    image: SnakeIcon,
    'image-black': SnakeBlackIcon,
  },
  speedwall: {
    name: 'Speedwall',
    image: SpeedwallIcon,
    'image-black': SpeedwallIconBlack,
  },
  strike: {
    // name: 'Strike',
    name: 'Zbijak',
    image: StrikeIcon,
    'image-black': StrikeBlackIcon,
  },
  takeoff: {
    // name: 'Takeoff',
    name: 'Odlot',
    image: TakeoffIcon,
    'image-black': TakeoffBlackIcon,
  },
};

export const LeagueName = 'ORLEN Liga Wspinaczkowa';

export const SEARCH_PARAMS = new URL(location.href).searchParams;
export const POLLING_INTERVAL = Math.max(
  Number(SEARCH_PARAMS.get('pollingInterval')) || 3000,
  1000,
);
export const API_ORIGIN =
  SEARCH_PARAMS.get('apiOrigin') || 'https://api.reclimb.com/';
export const STREAM_HOSTNAME =
  SEARCH_PARAMS.get('streamHostname') || 'streaming.reclimb.com';
export const STREAM_BASE = `wss://${STREAM_HOSTNAME}:3334/skywall/`;
